(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (e) => {
      const option = e.target.closest('.sorting-filter__option');
      if (!option) return;
      
      const input = option.querySelector('input[name="sort_by"]');
      if (!input) return;
      
      const sortValue = input.value;
      
      const details = option.closest('details');
      if (details) {
        details.removeAttribute('open');
      }
      
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      window.location.href = url.toString();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
